import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faAngleRight, faEllipsis } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import './Pager.css';

const SIZE = 5; // Размер скользящего "островка" пейджера (должен быть нечетным)

const Pager = ({ total, skip, limit, setSkip }) => {
	const { t } = useTranslation();
    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);
    const [ left, setLeft ] = useState(0);
    const [ right, setRight ] = useState(0);
    const [ center, setCenter ] = useState([]);

    useEffect(() => {
        // Вычислим сколько всего страниц
        let rd = total % limit; // остаток от деления
        let tp = (total - rd)/limit; // число страниц
        if(rd) tp ++;
        setTotalPages(tp);
        // Вычислим текущую страницу
        let cp = Math.floor(skip/limit + 1);
        setCurrentPage(cp);
        // Готовим части пейджера
        initParts(cp, tp);
    }, [total, skip, limit]);
    //
    // Центральная часть есть всегда, но может быть меньше SIZE
    // Правая и левые части появляются в зависимости от движения центра
    //
    const initParts = (currentPage, totalPages) => {
        let center = [];
        setLeft(0);
        setRight(0);
        // Если островок больше или равен totalPages, то в центре выведем все страницы
        if(totalPages <= SIZE) {
            for(let i = 1; i <= totalPages; i ++) {
                center.push(i);
            }
            setCenter(center);
            return;
        } 
        // Если мы прижаты влево, то в центре выведем первые SIZE страниц
        if(currentPage < SIZE/2 + 1) {
            for(let i = 1; i <= SIZE; i ++) {
                center.push(i);
            }
            setCenter(center);
            setRight(totalPages);
            return;
        }
        // Если мы прижаты вправо, то в центре выведем последние SIZE страниц
        if(currentPage + SIZE/2 >= totalPages) {
            for(let i = totalPages - SIZE + 1; i <= totalPages; i ++) {
                center.push(i);
            }
            setCenter(center);
            setLeft(1);
            return;
        }
        // В остальных случаях выводим скользящее окно
        let start = currentPage - Math.floor(SIZE/2);
        for(let i = start; i <= start + SIZE - 1; i ++ ) {
            center.push(i);
        }
        setCenter(center);
        setLeft(1);
        setRight(totalPages);        
    };
    // Нажали на кнопку предыдущая
    const onPrevPage = () => {
        setCurrentPage(currentPage - 1);
        setSkip(skip - limit);
    };
    // Нажали на кнопку следующая
    const onNextPage = () => {
        setCurrentPage(currentPage + 1);
        setSkip(skip + limit);
    };
    // Нажали на кнопку страницы
    const onPage = (page) => {
        setCurrentPage(page);
        setSkip((page - 1) * limit);
    };

    return(
    <React.Fragment>
        {totalPages > 1 &&
        <div className='Pager'>
            {/* Вывод кнопки "Прев" */}
            {currentPage > 1 ?
            <div className='Pager-prev' onClick={() => onPrevPage()}>
                <FontAwesomeIcon icon={faAngleLeft} size='lg'/>
                &nbsp;{t('pager.prev')}
            </div> :
            <div className='Pager-prev disabled'>
                <FontAwesomeIcon icon={faAngleLeft} size='lg'/>
                &nbsp;{t('pager.prev')}
            </div>}

            <div className='Pager-center'>
                {/* Вывод левой части */}
                {left > 0 &&
                <React.Fragment>
                    <span onClick={() => onPage(1)}>1</span>
                    {currentPage > SIZE/2 + 2 &&
                    <React.Fragment>
                        &nbsp;
                        <FontAwesomeIcon icon={faEllipsis} style={{color:'var(--border-color)'}}/>
                        &nbsp;
                    </React.Fragment>}
                </React.Fragment>}

                {/* Вывод центральной части */}
                {center.map(item => (
                    <span
                        key={item}
                        onClick={() => onPage(item)}
                        className={currentPage === item ? 'current' : null}
                    >
                        {item}
                    </span>
                ))}

                {/* Вывод правой части */}
                {right > 0 && 
                <React.Fragment>
                    {currentPage + SIZE/2 + 1 < totalPages &&
                    <React.Fragment>
                        &nbsp;
                        <FontAwesomeIcon icon={faEllipsis} style={{color:'var(--border-color)'}}/>
                        &nbsp;
                    </React.Fragment>}
                    <span onClick={() => onPage(right)}>{right}</span>
                </React.Fragment>}
            </div>

            {/*<div className='Pager-center'>
                {t('pager.page')} {currentPage} {t('pager.of')} {totalPages}
            </div>*/}

            {/* Вывод кнопки "След" */}
            {currentPage < totalPages ?
            <div className='Pager-next' onClick={() => onNextPage()}>
                {t('pager.next')}&nbsp;
                <FontAwesomeIcon icon={faAngleRight} size='lg'/>
            </div> :
            <div className='Pager-next disabled'>
                {t('pager.next')}&nbsp;
                <FontAwesomeIcon icon={faAngleRight} size='lg'/>
            </div>}
        </div>}
    </React.Fragment>
    );
};

Pager.propTypes = {
    total: PropTypes.number.isRequired,
    skip: PropTypes.number.isRequired,
    limit: PropTypes.number.isRequired,
    setSkip: PropTypes.func.isRequired,
};

export default Pager;
